var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomizationIcon = function SvgCustomizationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.688 9.5V8.375h4.033l-1.29-1.29.796-.795 2.648 2.648-2.648 2.647-.796-.795 1.29-1.29zM9.562 7.25H8.437V3.778l-1.29 1.29-.795-.795L9 1.625l2.648 2.648-.796.795-1.29-1.29zM9.563 11.807v-1.182a2.253 2.253 0 0 0-2.25-2.25H3.278l1.29-1.29-.795-.795-2.648 2.648 2.648 2.647.795-.795-1.29-1.29h4.034a1.126 1.126 0 0 1 1.125 1.125v1.182a2.812 2.812 0 1 0 1.126 0M9 16.25a1.688 1.688 0 1 1 0-3.375 1.688 1.688 0 0 1 0 3.375"
  })));
};
export default SvgCustomizationIcon;